<template>
  <el-dialog
    append-to-body
    width="700px"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <h2 style="text-align: center">保证金服务协议</h2>
    <div class="box-container">
      <div>
        <p>第一条 保证金规则</p>
        <p>
          1.1
          已认证通过的企业用户需缴纳3048元保证金方可开通校园聘平台（以下简称平台）招聘权限，缴纳后赠送100人才币（仅限简历下载使用）。
        </p>
        <p>
          1.2
          每成功入职1人，平台即从保证金中扣除500元作为服务费，系统根据求职者提供入职凭证判定成功入职即扣与入职时长无关
        </p>
        <p style="margin-bottom: 16px">
          1.3
          当保证金剩余额度低于3048元时，系统自动暂停新岗位发布及新简历下载/聊天功能，补缴后自动恢复（此前已收到和已下载的简历不受影响）。
        </p>
        <p>第二条 保证金管理</p>
        <p>
          2.1
          企业在本平台招聘成功入职后，保证金扣款不足时，需在三个工作日内补足，否则平台有权冻结账号并保留向企业追回与诉讼的权利。
        </p>
        <p style="margin-bottom: 16px">
          2.2
          保证金不计利息，企业申请退回保证金后15个工作日内退还扣除服务费后的余额。
        </p>
        <p>第三条 违约责任</p>
        <p>
          3.1
          若因求职方入职凭证信息有误导致扣费错误，平台应在收到企业反馈后2个工作日内核实后，退回误扣服务费。
        </p>
        <p style="margin-bottom: 16px">
          3.2 因系统故障导致扣费错误，平台应在核实后72小时内修正。
        </p>
        <p>第四条 其他条款</p>
        <p>
          4.1
          本协议解释权归平台所有，平台有权根据业务调整修改协议，修改协议需提前1天以上通过系统通知企业用户。
        </p>
        <p>
          4.2 争议解决适用中华人民共和国法律，协商不成提交甲方所在地法院诉讼。
        </p>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    reset(done) {
      this.visible = false;
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
  },
  mounted() {},
};
</script>
<style scoped lang="scss">
// ::v-deep .el-dialog__header {
//   display: none;
// }
::v-deep .el-dialog__headerbtn {
  top: 10px;
}
.box-container {
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-weight: 400;
  font-size: 16px;
  p {
    font-family: SimSun;
    line-height: 1.5;
  }
}
.img-box {
  margin: auto;
}
.margin-bottom-20 {
  margin-bottom: 20px;
}
.margin-bottom-10 {
  margin-bottom: 10px;
}
.btn {
  width: 240px;
  height: 48px;
  background: #0c64c6;
  border-radius: 4px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 18px;
  line-height: 48px;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
}
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.ti-2ch {
  text-indent: 2ch;
}
.code__wrap {
  margin: 0 auto;
  width: 250px;
  text-align: left;
  font-size: 16px;
}
.qrCodeUre {
  display: inline-block;
}
.mt15 {
  margin-top: 15px;
}
</style>
